import { propertyUseQuery, propertyQueryFn } from 'Services/reactQuery'

export const useFetchBuildingStats = ({ buildingId, enabled }) => (
  propertyUseQuery(
    ['buildingStats', buildingId],
    propertyQueryFn({ url: `buildings/${buildingId}/stats` }),
    { enabled })
)

export const useFetchBuildingMaintStats = ({ buildingId, enabled }) => (
  propertyUseQuery(
    ['buildingMaint', buildingId],
    propertyQueryFn({ url: `buildings/${buildingId}/maintenance-fees` }),
    { enabled })
)


export const useFetchListingStats = ({ areaType, areaId, enabled }) => (
  propertyUseQuery(
    ['listingStats', areaType, areaId],
    propertyQueryFn({ url: `${areaType}/${areaId}/stats` }),
    { enabled })
)

